import DOMPurify from 'dompurify'
import { Bell, Users } from 'lucide-react'
import { useNavigate } from 'react-router'
import Card from '../../../../components/common/Card'
import DefaultTable from '../../../../components/tables/DefaultTable/DefaultTable'
import { ProfessionalDetailType, useProfessional } from '../../../../context/ProfessionalContext'

const Notes = ({
    title,
    status,
    showTitle = true,
    cardClassName = '',
    bodyClassName = ''
}: {
    title: string
    status: number
    showTitle?: boolean
    cardClassName?: string
    bodyClassName?: string
}) => {
    const navigate = useNavigate()
    const { detail } = useProfessional()
    if (!detail) return null
    const notes = detail.notes
    const filteredNotes = notes.filter(note => String(note.status) === String(status))

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'note_',
            label: 'Nota'
        }
    ]

    // const changeNoteStatus = async ({ note }: { note: ProfessionalDetailType['notes'][number] }) => {
    //     if (!note || !note.id) {
    //         return toast.error('Erro ao atualizar status da nota!')
    //     }

    //     try {
    //         const formattedValues = {
    //             id: note.id,
    //             status: note.status === 0 ? 1 : 0
    //         }
    //         const response = await fetch(`${api}business/changeStatusNote`, {
    //             method: 'POST',
    //             body: JSON.stringify(formattedValues)
    //         })
    //         const result = await response.json()
    //         if (!result.success) {
    //             toast.error('Erro ao atualizar status da nota!')
    //             return
    //         }

    //         // Atualiza o estado do detalhe no contexto
    //         setDetail((prev: any) => {
    //             if (!prev) return prev

    //             const updatedNotes = prev.notes.map((item: any) =>
    //                 item.id === note.id ? { ...item, status: formattedValues.status } : item
    //             )

    //             return {
    //                 ...prev,
    //                 notes: updatedNotes
    //             }
    //         })

    //         toast.success('Nota atualizada com sucesso!')
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const formattedNotes = filteredNotes.map((item: ProfessionalDetailType['notes'][number]) => {
        const statusNote = {
            id: item.id,
            title: item.title,
            date: item.date,
            description: item.description,
            author: item.name,
            image: '',
            dateNotify: item.dateNotify || '',
            users: [],
            status: item.status,
            isExpired: item.isExpired
        }
        return {
            ...item,
            author: item.name,
            note_: (
                <div className='space-y-1'>
                    <div className='space-y-1'>
                        <div className='flex items-center justify-between'>
                            <div className='flex items-center gap-2'>
                                <p className='font-bold text-sm'>{item.name}</p>
                                <p className='opacity-80 text-sm'>{item.date}</p>
                            </div>
                            <div onClick={e => e.stopPropagation()}>
                                {/* <NoteStatus
                                    note={statusNote}
                                    changeNoteStatus={() => {
                                        changeNoteStatus({ note: item })
                                    }}
                                /> */}
                            </div>
                        </div>
                        <div className='flex items-center gap-3 opacity-80'>
                            {/* Lembrete */}
                            {item.dateNotify && (
                                <div className='flex items-center gap-1'>
                                    <Bell className='w-4 h-4 text-error-400' />
                                    <p className='text-sm opacity-80'>{item.dateNotify}</p>
                                </div>
                            )}
                            {/* Profissionais */}
                            {item.users && item.users.length > 0 && (
                                <div className='flex items-center gap-1'>
                                    <Users className='w-4 h-4 text-brand-400' />
                                    {item.users.map((user: any, index: number) => (
                                        <p className='text-sm text-gray-400'>
                                            {user.name}
                                            {index + 1 === item.users.length ? '' : ', '}
                                        </p>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <p
                        className='text-sm line-clamp-3 opacity-80'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description || '') }}
                    />
                </div>
            )
        }
    })

    const handleClick = (row: any) => {
        if (!row.businessID) return
        navigate(`/negocio/${row.businessID}`)
    }

    return (
        <>
            <Card className={cardClassName}>
                {showTitle && <h2 className='mb-4 text-base font-bold'>{title}</h2>}
                <div className={bodyClassName}>
                    <DefaultTable columns={columns} rows={formattedNotes} rowsPerPage={20} handleClick={handleClick} />
                </div>
            </Card>

            {/* Event detail drawer */}
            {/* <EventDetail event={note} open={open} handleClose={() => setOpen(false)} /> */}
        </>
    )
}

export default Notes
